"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadbandProductCategory = exports.HardwareProductCategory = exports.LandlineProductCategory = exports.PostpaidProductCategory = exports.PrepaidProductCategory = exports.ProductCluster = void 0;
/**
 * Enum für die Parameter
 * * product_cluster in ProductParameters
 * * order_old_product_cluster in OrderParameters
 * * user_stock_product_category in UserParameters
 */
var ProductCluster;
(function (ProductCluster) {
    ProductCluster["MOBILE"] = "mobilfunk";
    ProductCluster["LANDLINE"] = "festnetz";
    ProductCluster["HARDWARE"] = "hardware";
    ProductCluster["BROADBAND"] = "breitband";
})(ProductCluster || (exports.ProductCluster = ProductCluster = {}));
var PrepaidProductCategory;
(function (PrepaidProductCategory) {
    PrepaidProductCategory["PREPAID"] = "prepaid";
    PrepaidProductCategory["PREPAID_OPTION"] = "option_prepaid";
    PrepaidProductCategory["PREPAID_CREDIT"] = "guthaben";
    PrepaidProductCategory["SIM"] = "sim";
})(PrepaidProductCategory || (exports.PrepaidProductCategory = PrepaidProductCategory = {}));
var PostpaidProductCategory;
(function (PostpaidProductCategory) {
    PostpaidProductCategory["POSTPAID"] = "postpaid";
    PostpaidProductCategory["POSTPAID_OPTION"] = "option_postpaid";
    PostpaidProductCategory["SIM"] = "sim";
})(PostpaidProductCategory || (exports.PostpaidProductCategory = PostpaidProductCategory = {}));
var LandlineProductCategory;
(function (LandlineProductCategory) {
    LandlineProductCategory["DSL"] = "dsl";
    LandlineProductCategory["DSL_OPTION"] = "option";
})(LandlineProductCategory || (exports.LandlineProductCategory = LandlineProductCategory = {}));
var HardwareProductCategory;
(function (HardwareProductCategory) {
    HardwareProductCategory["MOBILE_PHONE"] = "handy";
    HardwareProductCategory["TABLET"] = "tablet";
    HardwareProductCategory["GADGET"] = "gadget";
    HardwareProductCategory["DSL_ROUTER"] = "dsl_router";
    HardwareProductCategory["LTE_ROUTER"] = "lte_router";
    HardwareProductCategory["ACCESSORIES"] = "zubehoer";
})(HardwareProductCategory || (exports.HardwareProductCategory = HardwareProductCategory = {}));
var BroadbandProductCategory;
(function (BroadbandProductCategory) {
    BroadbandProductCategory["DSL"] = "dsl";
})(BroadbandProductCategory || (exports.BroadbandProductCategory = BroadbandProductCategory = {}));
